import React, { useEffect, useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import InputMask from 'react-input-mask';

import Icon from '../Icon';

import classes from './styles.module.css';

function SearchTags({ defaultSearch, searchBy, onChangeSearch, onSearch, isDisabled }) {
    const [isOpened, setIsOpened] = useState(false);
    const [currentSelect, setCurrentSelect] = useState(defaultSearch || searchBy[0]);
    const [searchString, setSearchString] = useState('');
    const [tags, setTags] = useState([]);

    const selectRef = useRef(null);
    const listRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (listRef.current && selectRef.current && !selectRef.current.contains(e.target)) {
                setIsOpened(false);
            }
        };

        document.addEventListener('click', handleClickOutside, false);
        return () => document.removeEventListener('click', handleClickOutside, false);
    }, []);

    useEffect(() => {
        onChangeSearch(tags);
    }, [tags]);

    const toggleOpened = () => setIsOpened((prev) => !prev);

    const onChangeSearchString = (value) => {
        if (currentSelect.key === 'cardNumber') {
            setSearchString(value.replace(/•/g, ''));
        } else {
            setSearchString(value);
        }
    };

    const setCurrentSelectHandler = (val) => {
        if (currentSelect.key === 'cardNumber') {
            setSearchString('');
        }
        setCurrentSelect(val);
        setIsOpened(false);
    };

    const onDeleteTag = (index) => {
        setTags(tags.filter((_, i) => i !== index));
    };

    const addTag = () => {
        if (!searchString || !searchString.trim()) return;

        let newTag = {};

        if (['amountEqually', 'amountMore', 'rrn', 'amountLess', 'id', 'cardNumber'].includes(currentSelect.key)) {
            newTag = { [currentSelect.key]: Number(searchString), locale: currentSelect.locale };
        } else {
            if (currentSelect.key === 'phone') {
                const hasPhone = tags.some((tag) => tag.hasOwnProperty('phone'));
                if (hasPhone) return;
            }
            newTag = { [currentSelect.key]: searchString, locale: currentSelect.locale };
        }

        setTags([...tags, newTag]);
        setSearchString('');
    };

    const onKeyPress = (e) => {
        if (e.key === 'Enter') {
            addTag();
        }
    };

    return (
        <div className={classes.Card}>
            <div>
                {tags.length > 0 &&
                    tags.map((tag, index) => {
                        const value = Object.values(tag)[0];
                        return (
                            <div className={classes.Tag} key={index}>
                                <FormattedMessage id={tag.locale} defaultMessage="Не переведено" />: {value}
                                <Icon
                                    onClick={() => onDeleteTag(index)}
                                    className={classes.CloseIcon}
                                    icon="close"
                                    size="9px"
                                />
                            </div>
                        );
                    })}
            </div>

            <div className={`${classes.Search} ${isDisabled ? classes.Disabled : ''}`}>
                <div className={classes.SearchMeta}>
                    <div className={classes.Label}>
                        <FormattedMessage id="SearchTags.label" defaultMessage="Поиск по" />
                    </div>

                    <div ref={selectRef} className={classes.Select}>
                        <div onClick={toggleOpened} className={classes.Current}>
                            {isOpened ? (
                                <Icon className={classes.CurrentIcon} icon="cheveron-up" size="12px" />
                            ) : (
                                <Icon className={classes.CurrentIcon} icon="cheveron-down" size="12px" />
                            )}
                            <FormattedMessage id={currentSelect.locale} defaultMessage="Не переведено" />:
                        </div>

                        {isOpened && (
                            <ul ref={listRef} className={classes.List}>
                                {searchBy.map((el, i) => (
                                    <li
                                        key={i}
                                        onClick={() => setCurrentSelectHandler(el)}
                                        style={currentSelect.key === el.key ? { fontWeight: 'bold' } : {}}
                                        className={classes.Li}
                                    >
                                        <FormattedMessage id={el.locale} defaultMessage="Не переведено" />
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                </div>

                <div className={classes.InputWrap}>
                    {currentSelect.key === 'cardNumber' ? (
                        <FormattedMessage id={currentSelect.placeholder}>
                            {(placeholder) => (
                                <InputMask
                                    mask="999999••••9999"
                                    maskChar={null}
                                    className={classes.Input}
                                    placeholder={placeholder}
                                    value={searchString}
                                    onChange={(e) => onChangeSearchString(e.target.value)}
                                    onKeyPress={onKeyPress}
                                    maxLength="14"
                                />
                            )}
                        </FormattedMessage>
                    ) : currentSelect.key === 'phone' ? (
                        <InputMask
                            mask="+7 (999) 999-99-99"
                            maskChar={null}
                            className={classes.Input}
                            placeholder="+7 (___) ___-__-__"
                            value={searchString}
                            onChange={(e) => onChangeSearchString(e.target.value)}
                            onKeyPress={onKeyPress}
                        />
                    ) : (
                        <FormattedMessage id={currentSelect.placeholder}>
                            {(placeholder) => (
                                <input
                                    className={classes.Input}
                                    type="text"
                                    value={searchString}
                                    onChange={(e) => onChangeSearchString(e.target.value)}
                                    onKeyPress={onKeyPress}
                                    placeholder={placeholder}
                                    disabled={isDisabled}
                                />
                            )}
                        </FormattedMessage>
                    )}

                    {searchString ? (
                        <button type="button" onClick={addTag} className={classes.Btn}>
                            <FormattedMessage id="SearchTags.add" defaultMessage="добавить" />
                        </button>
                    ) : (
                        <Icon className={classes.SearchIcon} color="#999" icon="search" size="20px" />
                    )}
                </div>

                <div className={classes.Actions}>
                    <button
                        type="button"
                        onClick={() => {
                            if (typeof onSearch === 'function') {
                                onSearch(tags);
                            }
                        }}
                        className={classes.SearchBtn}
                        disabled={isDisabled}
                    >
                        <FormattedMessage id="SearchTags.search" defaultMessage="Найти" />
                    </button>
                </div>
            </div>
        </div>
    );
}

export default SearchTags;



// WEBPACK FOOTER //
// ./src/Components/Utils/SearchTags/index.js